import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";

@Injectable({providedIn:'root'})
export class StorageProvider {
    _storage:Storage = null;

    constructor(private storage: Storage) {
    }
    async create() {
        if(!this._storage){
            this._storage = await this.storage.create();
        }
    }

    removeData(key) {
        return new Promise<any>((resolve, reject) => {
            this.create().then(()=>{
                this._storage.remove(key).then(() => resolve).catch(() => reject());
            })
        });
    }

    checkForExistance(key) {
        return new Promise<any>((resolve, reject) => {
            this.create().then(()=>{
                this._storage.keys().then((data) => {
                    let table = data.includes(key);
                    if (table) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                });
            })
        });
    }

    getSaved(type, isToken: boolean = false): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.create().then(()=>{
                this._storage.get(type).then((data) => {
                    if (data) {
                        if (isToken)
                            resolve(data);
                        else
                            resolve(JSON.parse(data));
                    } else {
                        resolve(null);
                    }
                });
            });
        });
    }
    saveData(data, type): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.create().then(()=>{
                this._storage.set(type, JSON.stringify(data)).then(() => resolve(null));
            });
        });
    }


}